import copy from 'copy-text-to-clipboard';

(function () {

  const button = document.querySelector('.copy-to-clipboard-button');

  if (!button) return;

  button.addEventListener('click', (e) => {
    e.preventDefault();
    const button = e.currentTarget;
    button.classList.add('copied');
    window.setTimeout( () => {
      button.classList.remove('copied');
    }, 1000)
  	return copy(button.href);
  });

})()
